export default __webpack_public_path__ + "static/media/location_markers.f64563ea.svg";